import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=68b2ef25&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=68b2ef25&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b2ef25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b2ef25')) {
      api.createRecord('68b2ef25', component.options)
    } else {
      api.reload('68b2ef25', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=68b2ef25&scoped=true", function () {
      api.rerender('68b2ef25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/investments/firm-fee-schedule-manager/Form.vue"
export default component.exports